import { render, staticRenderFns } from "./listGroupMember.vue?vue&type=template&id=08110e7b&"
import script from "./listGroupMember.vue?vue&type=script&lang=js&"
export * from "./listGroupMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports